<template>
  <div class="tag--default" :class="tagClass" @click="removeTag">
    <span class="tag-title">
     <slot></slot>
    </span>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue';


export default defineComponent({
  name: 'TagElement',
  components: {
  },
  props: {
    title: {
      type: String,
      default: 'Tag',
    },
    withCloseButton: {
      type: Boolean,
      default: true, // false olmali
    },
    class: {
      type: String as PropType<
        | 'tag--neutral'
        | 'tag-google'
        | 'tag-light-grey'
        | 'tag--accent'
      >,
      default: 'tag-light-grey',
    },
  },
  data() {
    return {
      tagClass: this.class,
    };
  },
  methods: {
    removeTag() {
      this.$emit('tagRemove');
    },
  },
});
</script>
<style lang="scss" scoped>

  .btn{
    &:hover{
      .tag-remove{
        display: flex;
      }
    }
    .tag-remove{
      display: none;
    }
  }
  .tag {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-size: var(--fs-12);
    font-weight: 600;
    height: 28px;
    padding: 0 10px;
    margin: var(--space-0);
    border-radius: $br-sm;
    line-height: 20px;

    .tag-remove {
      margin-left: 6px;

      &:hover {
        cursor: pointer;
      }
    }

  &.tag-default {
    color: var(--text-neutral);
  }

  &.tag-success {
    color: var(--text-light);
    background-color: var(--green-100);
    border-color: var(--green-100);
  }

  &.tag-error {
    color: var(--text-light);
    background-color: var(--red-100);
    border-color: var(--red-100);
  }

  &.tag-grey {
    background-color: var(--neutral-200);
    border-color: var(--neutral-200);
    color: var(--text-light);
  }

  &.tag-roles{
    width: 65px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: normal;
  }

  &.tag-light-grey {
    background-color: var(--light-300);
    border-color: var(--light-300);
    color: var(--text-neutral);
  }

  &.tag-purple {
    background-color: var(--accent-100);
    border-color: var(--accent-100);
    color: var(--text-light);
  }
}
</style>
